import 'fontsource-gorditas'
import 'fontsource-inder'
import { wrapPageElement as wrap } from './src/wappy-mc-wap-wap'

export const wrapPageElement = wrap
